import cx from 'classnames';
import React from 'react';

import './activity-type-icon.scss';

interface Props {
    backgroundColor?: string;
    children?: React.ReactNode;
    mix?: string;
}

export const ActivityTypeIcon = (props: Props) => {
    const { backgroundColor, children, mix } = props;

    const style: React.CSSProperties = {};
    if (backgroundColor) {
        style.backgroundColor = backgroundColor;
    }

    return (
        <div className={cx('activity-type-icon', mix)} style={style}>
            {children}
        </div>
    );
};
